import baseAPI from "@/api/base";
import {
  ConnectIntegration,
  EditIntegration,
  GetIntegration,
  RegisterIntegration,
} from "@/dtos/Integration.dto";
import {
  DELETE_INTEGRATION_URL,
  EDIT_INTEGRATION_URL,
  GET_INTEGRATION_URL,
  REGISTER_INTEGRATION_URL,
  TOGGLE_INTEGRATION_IS_ACTIVE_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class Integration {
  static connectIntegration = async (
    connectIntegration: ConnectIntegration
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(
      `${GET_INTEGRATION_URL}/${connectIntegration.provider}/connect`,
      {
        params: connectIntegration,
        withCredentials: true,
      }
    );
    return response;
  };

  static disconnectIntegration = async (
    connectIntegration: ConnectIntegration
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(
      `${GET_INTEGRATION_URL}/${connectIntegration.provider}/disconnect`,
      {
        params: connectIntegration,
      }
    );
    return response;
  };

  static getIntegrations = async (getIntegration: GetIntegration): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_INTEGRATION_URL, {
      params: getIntegration,
    });
    return response;
  };

  static registerIntegration = async (
    registerIntegration: RegisterIntegration
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_INTEGRATION_URL, {
      ...registerIntegration,
    });
    return response;
  };

  static editIntegration = async (editIntegration: EditIntegration): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_INTEGRATION_URL, {
      ...editIntegration,
    });
    return response;
  };

  static toggleIntegrationIsActive = async (
    editIntegration: EditIntegration
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(TOGGLE_INTEGRATION_IS_ACTIVE_URL, {
      ...editIntegration,
    });
    return response;
  };

  static deleteIntegration = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(`${DELETE_INTEGRATION_URL}/${id}`);
    return response;
  };
}

export default Integration;
